var map = {
	"./blog_grid_1.jpg": 497,
	"./blog_grid_2.jpg": 498,
	"./blog_grid_3.jpg": 499,
	"./blog_grid_4.jpg": 500,
	"./blog_grid_5.jpg": 501,
	"./blog_grid_6.jpg": 502,
	"./blog_grid_7.jpg": 503,
	"./blog_grid_8.jpg": 504
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 983;